import { DataFormPage } from "~/pages/DataFormPage";
import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/custom/create")({
  component: RouteComponent,
});

function RouteComponent() {
  useBreadCrumbs([
    { title: "Custom", link: `#` },
    { title: "Create", link: `/${location.pathname.split("/")[1]}/data/custom/create` },
  ]);

  return (
    <div className="mx-5 pb-4">
      <h1 className="text-2xl font-bold mb-6">Create Custom Entity</h1>
      <div className="[&_.max-w-2xl]:max-w-full! [&_.mx-auto]:mx-0! [&>div]:m-0!">
        <DataFormPage
          hideHeader={false}
          customTitle="Entity Configuration"
          customDescription="Define the basic properties and attributes for your new custom entity."
        />
      </div>
    </div>
  );
}
